import { render, staticRenderFns } from "./EditGlobalTagModal.vue?vue&type=template&id=07461cf4&lang=pug&"
import script from "./EditGlobalTagModal.vue?vue&type=script&lang=js&"
export * from "./EditGlobalTagModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports